import { render, staticRenderFns } from "./OwalTransitionMagnet.vue?vue&type=template&id=758df908&scoped=true"
import script from "./OwalTransitionMagnet.vue?vue&type=script&lang=js"
export * from "./OwalTransitionMagnet.vue?vue&type=script&lang=js"
import style0 from "./OwalTransitionMagnet.vue?vue&type=style&index=0&id=758df908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758df908",
  null
  
)

export default component.exports